<template>
  <div class="abspopup">
    <div v-if="isTitle" class="popup-header">
      <h2 :class="titleState">{{ title }}</h2>
    </div>
    <div class="abspopup-body" :class="bodyalign" @scroll="$emit('scroll', $event)">
      <slot name="body"></slot>
    </div>
    <div class="popup-footer">
      <UbuttonList size="small" :align="align" :data="buttonList"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    option: {
      type: Object
    },
    isTitle: {
      type: Boolean,
      default: true
    },
    titleState: {
      type: String,
      default: 'title'
    },
    title: {
      type: String,
      default: 'AbsPopup'
    },
    type: {
      type: String,
      default: 'confirm'
    },
    require: {
      type: Boolean,
      default: false
    },
    initButtonList: {
      type: Array
    },
    bodyalign: {
      type: String,
      default: 'center'
    }
  },
  created () {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  name: 'AbsPopup',
  computed: {
    buttonList () {
      if (this.initButtonList) {
        return this.initButtonList
      } else {
        switch (this.type) {
          case 'confirm' :
            return [
              {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
              {name: '확인', state: this.state, click: this.submit}
            ]
          case 'alert' :
            return [
              {name: '확인', state: this.state, click: () => { this.$emit('close') }}
            ]
        }
      }
    },
    state () {
      switch (this.type) {
        case 'confirm' :
          return (this.require) ? 'require' : 'active'
        case 'alert' :
          return (this.require) ? 'require' : 'active'
      }
    },
    align () {
      switch (this.type) {
        case 'confirm' :
          return 'popup'
        case 'alert' :
          return 'center'
      }
    }
  },
  methods: {
    submit () {
      console.log('abspopup submitHandler')
      this.$emit('submit')
    }
  },
  components: {
  }
}
</script>

<style scoped>
.abspopup {
  padding: 10px 0px;
  max-height: calc(100vh - 55px);
}
.abspopup > div {
  min-width: 300px;
}
.popup-header {
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid var(--line-base);
  padding-bottom: 10px;
}
.popup-header h2 {
  margin: 0px;
}
.abspopup-body {
  overflow-y: auto;
  display: flex;
}
.abspopup-body.center {
  align-items: center;
  justify-content: center;
}
.popup-footer {
  padding-top: 10px;
  border-top: 1px solid var(--line-guide);
  width: 100%;
  display: flex;
}
.abspopup-body::-webkit-scrollbar {width:5px;}
.abspopup-body::-webkit-scrollbar-track { background-color: #fFfFfF; }
.abspopup-body::-webkit-scrollbar-thumb { background: #DDDDDD }
.abspopup-body::-webkit-scrollbar-button { display: none; }
</style>



// WEBPACK FOOTER //
// src/components/popup/AbsPopup.vue